export default __webpack_public_path__ + "static/media/1561.9cbd8726.png";